<div class="dialog">
  <div class="dialog__container">
    <mat-icon class="dialog__container-icon" [svgIcon]="data.icon"></mat-icon>
    <div class="dialog__container-text">
      <h1 class="title">{{ data.title }}</h1>
      <h3 class="subtitle">{{ data.subtitle }}</h3>
    </div>
  </div>
  <section class="dialog__buttons">
    <app-button-basic (onClickButtonEvent)="closeDialog(data?.buttonAcceptValue)" [bgColor]="'#fd7394'"
      [textColor]="'#ffffff'" [buttonText]="data.buttonText"></app-button-basic>
  </section>
</div>